/**
 * UI表示用に、カード番号を分割する
 *
 * @param {{ cardNumber: string, groupSize: number }} params
 */
export const formatCardNumber = (params: {
  cardNumber: string;
  groupSize: number;
}): string => {
  const { cardNumber, groupSize } = params;
  const regex = new RegExp(`\\d{${groupSize}}(?=.)`, 'g');
  return cardNumber.replace(regex, '$& ');
};
